import Api from "../axios";

export const getGameDetails = async (id) => {
  return await Api.get(`Game/GameDetails?GameID=${id}`);
};
